<template>
    <div id='app'>
        <div class="notification is-info is-light" :class='[display, type]'>
            <button class="delete" @click='notificationDelete'></button>
            {{ notificationMessage }}
        </div>
        <div id='content'>
            <router-view/>
        </div>
    </div>
</template>

<script>

export default {
    name: 'app',
    data () {
        return {
            notificationMessage: '',
            display: 'none',
            type: 'is-primary',
            notificationUpdate: 0
        }
    },
    mounted () {
        const self = this

        self.$root.$on('logout', () => {
            if (window.confirm('ログアウトしますか？')) {
                self.axios.post(`${process.env.API_URL}/logout`).then((res) => {
                    self.$router.push('/login')
                }).catch((e) => {
                    alert('サーバーエラーが発生しました')
                })
            }
        })

        self.$root.$on('notification', (type, text) => {
            self.type = type
            self.notificationMessage = text
            self.display = 'inline'

            self.notificationUpdate++

            setTimeout(() => {
                self.notificationUpdate--
                if (self.notificationUpdate === 0) {
                    self.display = 'none'
                }
            }, 5000)
        })
    },
    methods: {
        notificationDelete () {
            this.display = 'none'
        }
    }
}
</script>

<style>
@import 'bulma/css/bulma.css';
@import 'bulma-tooltip/dist/css/bulma-tooltip.min.css';

.button {
    font-weight: bold;
}

.checkbox {
    white-space: nowrap;
}

.notification {
    width: 100%;
    position: fixed;
    z-index: 1000000000;
    text-align: center;
}

.inline {
    display: inline;
}

.none {
    display: none;
}

.table-container {
    overflow: scroll;
    width: 80vw;
}

.title-1 {
    font-weight: bold;
    font-size: 20px;
}

select:not(.native-select) {
    font-size: 15px;
    height: 40px;
    padding: 6px 32px 6px 12px;
    border: 1px solid #cfcfcf;
    border-radius: 6px;
    background-color: #fff;
    color: #222;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image:
        linear-gradient(45deg, transparent 50%, #666 50%),
        linear-gradient(135deg, #666 50%, transparent 50%),
        linear-gradient(to right, #e6e6e6, #e6e6e6);
    background-position:
        calc(100% - 18px) 16px,
        calc(100% - 12px) 16px,
        calc(100% - 36px) 50%;
    background-size: 6px 6px, 6px 6px, 1px 18px;
    background-repeat: no-repeat;
}

select:not(.native-select):focus {
    outline: none;
    border-color: #1f7ae0;
    box-shadow: 0 0 0 3px rgba(31, 122, 224, 0.15);
}

select:not(.native-select):disabled {
    background-color: #f5f5f5;
    color: #888;
}

</style>



// WEBPACK FOOTER //
// src/App.vue